import React, { useEffect, useRef, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

import './agriculture-modal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAdd,
  faCircleXmark,
  faFilePdf,
  faMinus,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import {
  IconButton,
  FormControlLabel,
  Radio,
  FormLabel,
  RadioGroup,
  FormControl,
  TextField,
  FormGroup,
  Switch,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import ButtonUI from '../../../../components/ui/button/button';
import FieldsetUI from '../../../../components/ui/fieldset/fieldset';
import PreviewImageUI from '../../../../components/ui/preview-image/preview-image';
import { svCreateProduct } from '../../../../services/productServices/pageagriculture.service';
import SwalUI from '../../../../components/ui/swal-ui/swal-ui';
// import CKeditorComponent from '../../../../components/ui/ckeditor/ckeditor';

function AgricultureAddModal(props) {
  const {
    t,
    isOpen,
    category,
    maxPriority,
    setMaxPriority,
    higCategoryPriority,
    setClose,
    setRefreshData,
    segment,
  } = props;
  const [previews, setPreviews] = useState({ src: '', file: null, name: null });
  const [previewsSlides, setPreviewsSlides] = useState({
    src: '',
    file: null,
    name: null,
  });
  const [isError, setIsError] = useState({
    thumbnail: false,
    thumbnail_second: false,
    // slug: false,
    // keyword:false,
    title: false,
    category: false,
    // description: false,
    seement: false,
    plant_line1: false,
    plant_line2: false,
    plant_line3: false,
    fruit_line1: false,
    fruit_line2: false,
    fruit_line3: false,
    taste_line1: false,
    taste_line2: false,
    disease_line1: false,
    disease_line2: false,
    segment: false,
    link_youtube: false,
    pdf: false,
  });

  const initProductData = {
    // keyword:"",
    // slug: '',
    title: '',
    // description: '',
    seement: '',
    plant_line1: '',
    plant_line2: '',
    plant_line3: '',
    fruit_line1: '',
    fruit_line2: '',
    fruit_line3: '',
    taste_line1: '',
    taste_line2: '',
    disease_line1: '',
    disease_line2: '',
    category: '',
    imageName: '',
    thumbnail_title: '',
    thumbnail_alt: '',
    thumbnail_slides_name: '',
    thumbnail_slides_title: '',
    thumbnail_slides_alt: '',
    link_youtube: '',
    display: true,
    new: false,
    priority: Number(maxPriority) + 1,
  };

  const language = useSelector((state) => state.app.language);
  const defaultLanguage = useSelector((state) => state.app.defaultLanguage);
  const [addData, setAddData] = useState(initProductData);
  // const [ckValue, setCkValue] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const scrollRef = useRef(null);
  const inpFile = useRef(null);
  const titleFile = useRef();
  const [tegegmentList, setTegegmentList] = useState([]);
  const [fileDoc, setFileDoc] = useState(null);
  const [fileName, setFileName] = useState('');

  const textInputDoc = t('textInputDoc');

  useEffect(() => {
    setAddData((prevState) => ({
      ...prevState,
      priority: Number(maxPriority) + 1,
    }));
  }, [maxPriority]);

  const setPreviewHandler = (data) => {
    setAddData({ ...addData, imageName: data.file ? data.file.name : '' });
    setPreviews(data);
  };

  const setPreviewSlidesHandler = (data) => {
    setAddData({
      ...addData,
      thumbnail_slides_name: data.file ? data.file.name : '',
    });
    setPreviewsSlides(data);
  };

  const priorityHandler = (isAdding) => {
    if (isAdding) {
      setAddData((prevState) => {
        return { ...prevState, priority: parseInt(addData.priority) + 1 };
      });
    } else if (addData.priority > 1) {
      setAddData((prevState) => {
        return { ...prevState, priority: parseInt(addData.priority) - 1 };
      });
    }
  };

  const addValidators = () => {
    let isValid = true;

    let error = {
      ...isError,
      category: addData.category === '',
      thumbnail: previews.file === null || !previews.file,
      thumbnail_second: previewsSlides.file === null || !previewsSlides.file,
      title: addData.title.trim().length < 1,
      segment: addData.seement === '',
      plant_line1: addData.plant_line1.trim().length < 1,
      plant_line2: addData.plant_line2.trim().length < 1,
      plant_line3: addData.plant_line3.trim().length < 1,
      fruit_line1: addData.fruit_line1.trim().length < 1,
      fruit_line2: addData.fruit_line2.trim().length < 1,
      fruit_line3: addData.fruit_line3.trim().length < 1,
      taste_line1: addData.taste_line1.trim().length < 1,
      taste_line2: addData.taste_line2.trim().length < 1,
      disease_line1: addData.disease_line1.trim().length < 1,
      disease_line2: addData.disease_line2.trim().length < 1,

      // keyword: addData.keyword.trim().length < 1,

      // description: addData.description.trim().length < 1,
      // slug: addData.slug.trim().length < 1,
    };
    setIsError(() => error);

    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;

    if (isValid) {
      const embed_url = addData.link_youtube.replace('/watch?v=', '/embed/');
      const formData = new FormData();
      if (previews.file) {
        formData.append('Image', previews.file);
        formData.append('ImageName', addData.imageName);
        formData.append('thumbnail_title', addData.thumbnail_title);
        formData.append('thumbnail_alt', addData.thumbnail_alt);
      }
      if (previewsSlides.file) {
        formData.append('ImageSecond', previewsSlides.file);
        formData.append('thumbnailSecond_name', addData.thumbnail_slides_name);
        formData.append(
          'thumbnailSecond_title',
          addData.thumbnail_slides_title
        );
        formData.append('thumbnailSecond_alt', addData.thumbnail_slides_alt);
      }
      formData.append('category', addData.category);
      formData.append('title', addData.title);
      // formData.append('description', ckValue);
      // formData.append('slug', addData.slug);
      // formData.append("keyword", addData.keyword);
      formData.append('seement', addData.seement);
      formData.append('plantLine1', addData.plant_line1);
      formData.append('plantLine2', addData.plant_line2);
      formData.append('plantLine3', addData.plant_line3);
      formData.append('fruitLine1', addData.fruit_line1);
      formData.append('fruitLine2', addData.fruit_line2);
      formData.append('fruitLine3', addData.fruit_line3);
      formData.append('tasteLine1', addData.taste_line1);
      formData.append('tasteLine2', addData.taste_line2);
      formData.append('diseaseLine1', addData.disease_line1);
      formData.append('diseaseLine2', addData.disease_line2);
      formData.append('link_youtube', embed_url);
      if (fileDoc) {
        formData.append('pdf', fileDoc);
        formData.append('pdfName', fileName);
      }
      // formData.append("link_facebook", addData.link_facebook);
      // formData.append("link_twitter", addData.link_twitter);

      formData.append('display', addData.display ? 1 : 0);
      formData.append('p_new', addData.new ? 1 : 0);
      formData.append('priority', addData.priority);
      formData.append('language', defaultLanguage);
      /* Display the key/value pairs*/
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
      // return false;
      saveHandler(formData);
    } else {
      scrollToTop();
    }
  };

  const scrollToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const uploadPreview = (e) => {
    const file = e.target.files[0];
    e.value = null;
    setFileDoc(file);
    setFileName(file.name.split('.')[0] + language);
    let fileSize = parseFloat(file.size / (1024 * 1024)).toFixed(2);
    titleFile.current.textContent = `${file.name} (${fileSize}mb)`;
  };

  const saveHandler = (formData) => {
    setIsFetching(true);

    svCreateProduct(formData).then((res) => {
      console.log(res);

      if (res.status === 200) {
        setClose(false);
        setIsFetching(false);
        SwalUI({ status: res.data.status, description: res.data.description });
        setRefreshData((prev) => prev + 1);
      } else {
        setClose(true);
        setIsFetching(false);
        console.log('123');
        let error = {
          ...isError,
          slug: true,
        };
        setIsError(() => error);
        // SwalUI({ status: res.data.status, description: res.data.description });
      }
    });
  };

  const segmentHandleChange = (event) => {
    let seementSelect = segment.filter(
      (item) => item.id === event.target.value
    );
    console.log(seementSelect);
    setAddData((prevState) => {
      return {
        ...prevState,
        // title: seementSelect[0].title,
        seement: event.target.value,
      };
    });
  };

  const onResetFileDoc = () => {
    setFileDoc(null);
    setFileName('');
    inpFile.current.value = '';
    titleFile.current.textContent = textInputDoc;
  };

  // console.log(addData.priority);
  return (
    <Modal
      disableEnforceFocus
      open={isOpen}
      onClose={() => setClose(false)}
      className={'modal-add-agriculture'}
      aria-labelledby="modal-add-agriculture"
      aria-describedby="modal-add-agriculture"
    >
      <Box className="modal-custom">
        <div className="modal-header">
          <h2>
            <FontAwesomeIcon icon={faAdd} />
            <span>{t('AgriAdd')}</span>
          </h2>
          <IconButton
            className="param-generator"
            color="error"
            sx={{ p: '10px' }}
            onClick={() => setClose(false)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </div>

        <div className="modal-body overflow-scroll-custom">
          <fieldset className="modal-fieldset">
            {/* RadioBoxUI */}
            <div
              className={`box-checkbox-container cate-menu-list 
              ${isError.category ? 'error' : ''}`}
            >
              <div className="brc-body overflow-scroll-custom">
                <FormControl className="brc-form-control">
                  <FormLabel id="box-checkbox">{t('Category')}</FormLabel>
                  <RadioGroup
                    aria-labelledby="box-checkbox"
                    name="controlled-checkbox-buttons-group"
                  >
                    {category &&
                      category.map((item) => (
                        // 1. ใช้ div และกำหนด key ให้กับ div
                        <div key={item.id}>
                          {/* Category Radio Button */}
                          <FormControlLabel
                            onChange={(e) => {
                              setTegegmentList(item.segments_data);
                              let filtered = higCategoryPriority.filter(
                                (i) => i.id === item.id
                              );
                              setMaxPriority(filtered[0]?.max_priority || 0);
                              setAddData((prevState) => ({
                                ...prevState,
                                category: e.target.value,
                              }));
                            }}
                            value={item.id}
                            control={<Radio />}
                            label={item.title}
                          />
                        </div>
                      ))}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className="form-details">
              {/* รูป */}
              <div className="image-box">
                <FieldsetUI
                  className={`image-setting ${
                    isError.thumbnail ? 'error' : ''
                  }`}
                  label={t('รูปผล')}
                  label2={'750*590 px'}
                >
                  <PreviewImageUI
                    className="add-image"
                    previews={previews}
                    setPreviews={setPreviewHandler}
                    setData={setAddData}
                  />
                  <div className="image-detail">
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, imageName: e.target.value };
                        })
                      }
                      value={addData.imageName}
                      className={`text-field-custom ${
                        !previews.file ? 'inp-hidden' : ''
                      }`}
                      fullWidth={true}
                      error={false}
                      id="image-name"
                      label={t('ModalImageName')}
                      size="small"
                    />
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            thumbnail_title: e.target.value,
                          };
                        })
                      }
                      value={addData.thumbnail_title}
                      className="text-field-custom"
                      fullWidth={true}
                      error={false}
                      id="image-title"
                      label={t('ModalImageTitle')}
                      size="small"
                    />
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            thumbnail_alt: e.target.value,
                          };
                        })
                      }
                      value={addData.thumbnail_alt}
                      className="text-field-custom"
                      fullWidth={true}
                      error={false}
                      id="image-tag"
                      label={t('ModalAltDescription')}
                      size="small"
                    />
                  </div>
                </FieldsetUI>
                {/* รูป2 */}
                <FieldsetUI
                  className={`image-setting ${
                    isError.thumbnail ? 'error' : ''
                  }`}
                  label={t('รูปต้น')}
                  label2={'750*590 px'}
                >
                  <PreviewImageUI
                    className={`add-imageSlides ${
                      isError.thumbnail_slides ? 'error' : ''
                    }`}
                    previews={previewsSlides}
                    setPreviews={setPreviewSlidesHandler}
                    setData={setAddData}
                    inputFileStyle={{
                      border: isError.imageInfo ? '1px solid red' : '',
                    }}
                  />
                  <div className="image-detail">
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            thumbnail_slides_name: e.target.value,
                          };
                        })
                      }
                      value={addData.thumbnail_slides_name}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.thumbnail_slides_name}
                      id="image-name"
                      label="ImageSecond name"
                      size="small"
                    />
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            thumbnail_slides_title: e.target.value,
                          };
                        })
                      }
                      value={addData.thumbnail_slides_title}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.thumbnail_slides_title}
                      id="image-title"
                      label="ImageSecond title"
                      size="small"
                    />
                    <TextField
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            thumbnail_slides_alt: e.target.value,
                          };
                        })
                      }
                      value={addData.thumbnail_slides_alt}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.thumbnail_slides_alt}
                      id="image-tag"
                      label="ImageSecond description"
                      size="small"
                    />
                  </div>
                </FieldsetUI>
              </div>
              {/* รายละเอียด */}
              <div className="category-details">
                <h3 className="category-detail-title">{t('ModalDetail')}</h3>
                <div className="input-half">
                  {/* segment */}
                  <FormControl
                    sx={{ width: '100%', marginTop: '12px' }}
                    size="small"
                    error={isError.segment}
                  >
                    <InputLabel id="demo-select-small-label">
                      segment
                    </InputLabel>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={addData.seement}
                      label="segment"
                      onChange={segmentHandleChange}
                    >
                      {addData.category === '' && (
                        <MenuItem value="">
                          <em>{t('Select A Category')}</em>
                        </MenuItem>
                      )}
                      {segment &&
                        tegegmentList.map((e) => {
                          return (
                            <MenuItem key={e.id} value={e.id}>
                              {e.title}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
                <div className="input-half">
                  {/* ชื่อสินค้า */}
                  <TextField
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, title: e.target.value };
                      })
                    }
                    value={addData.title}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.title}
                    id="ad-slug"
                    label={t('ModalCategorieskeyword')}
                    size="small"
                  />
                </div>

                {/* <div className="ck-content">
                  <label className="ck-add-agriculture">{t('ModalAgricultureDescription')}</label>
                  <CKeditorComponent
                    className="ck-add-agriculture"
                    ckNameId="ck-add-agriculture"
                    value={ckValue}
                    onUpdate={setCkValue}
                  />
                </div> */}

                {/* plant */}
                <FieldsetUI className="plant-group " label={'plant'}>
                  <div className="group-detail">
                    <TextField
                      id="outlined-basic"
                      label="line-1"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, plant_line1: e.target.value };
                        })
                      }
                      value={addData.plant_line1}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.plant_line1}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-2"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, plant_line2: e.target.value };
                        })
                      }
                      value={addData.plant_line2}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.plant_line2}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-3"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, plant_line3: e.target.value };
                        })
                      }
                      value={addData.plant_line3}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.plant_line3}
                    />
                  </div>
                </FieldsetUI>
                {/* fruit */}
                <FieldsetUI className="plant-group " label={'fruit'}>
                  <div className="group-detail">
                    <TextField
                      id="outlined-basic"
                      label="line-1"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, fruit_line1: e.target.value };
                        })
                      }
                      value={addData.fruit_line1}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.fruit_line1}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-2"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, fruit_line2: e.target.value };
                        })
                      }
                      value={addData.fruit_line2}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.fruit_line2}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-3"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, fruit_line3: e.target.value };
                        })
                      }
                      value={addData.fruit_line3}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.fruit_line3}
                    />
                  </div>
                </FieldsetUI>
                {/* taste */}
                <FieldsetUI className="plant-group " label={'taste'}>
                  <div className="group-detail">
                    <TextField
                      id="outlined-basic"
                      label="line-1"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, taste_line1: e.target.value };
                        })
                      }
                      value={addData.taste_line1}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.taste_line1}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-2"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return { ...prevState, taste_line2: e.target.value };
                        })
                      }
                      value={addData.taste_line2}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.taste_line2}
                    />
                  </div>
                </FieldsetUI>
                {/* disease */}
                <FieldsetUI className="plant-group " label={'disease'}>
                  <div className="group-detail">
                    <TextField
                      id="outlined-basic"
                      label="line-1"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            disease_line1: e.target.value,
                          };
                        })
                      }
                      value={addData.disease_line1}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.disease_line1}
                    />
                    <TextField
                      id="outlined-basic"
                      label="line-2"
                      onChange={(e) =>
                        setAddData((prevState) => {
                          return {
                            ...prevState,
                            disease_line2: e.target.value,
                          };
                        })
                      }
                      value={addData.disease_line2}
                      className="text-field-custom"
                      fullWidth={true}
                      error={isError.disease_line2}
                    />
                  </div>
                </FieldsetUI>
                {/* <div className="input-half">
                  <TextField
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, hr: e.target.value };
                      })
                    }
                    value={addData.hr}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.hr}
                    id="ad-hr"
                    label={t('hr')}
                    size="small"
                  />
                </div>
                <div className="input-half">
                  <TextField
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, ir: e.target.value };
                      })
                    }
                    value={addData.ir}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.ir}
                    id="ad-ir"
                    label={t('ir')}
                    size="small"
                  />
                </div> */}
                <div className="input-full">
                  <TextField
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, link_youtube: e.target.value };
                      })
                    }
                    value={addData.link_youtube}
                    className="text-field-custom"
                    fullWidth={true}
                    error={isError.link_youtube}
                    id="ad-linkYoutube"
                    label={t('Link Youtube')}
                    size="small"
                  />
                </div>

                <div className="input-full">
                  <input
                    type="file"
                    className="input-file"
                    ref={inpFile}
                    accept="*/*"
                    onChange={uploadPreview}
                  />
                  <div className="select-doc">
                    <ButtonUI
                      loader={false}
                      icon={<FontAwesomeIcon icon={faFilePdf} />}
                      className="btn-save"
                      on="add"
                      fullWidth={true}
                      onClick={() => inpFile.current.click()}
                    >
                      {t('Selectdocument')}
                    </ButtonUI>
                    <div className="fileName" ref={titleFile}>
                      {' '}
                      {textInputDoc}
                    </div>
                    <button onClick={onResetFileDoc}>
                      {fileDoc && (
                        <FontAwesomeIcon
                          icon={faCircleXmark}
                          style={{ color: '#ff0000' }}
                        />
                      )}
                    </button>
                  </div>
                </div>
                {/* Settings */}
                <div className="group-settings">
                  <h3 className="post-detail-titile">{t('Settings')}</h3>
                  <div className="setting-controls">
                    <div className="switch-form">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  display: e.target.checked,
                                })
                              }
                              checked={addData.display ? true : false}
                            />
                          }
                          label={t('display')} //การแสดงผล
                          labelPlacement="start"
                        />
                      </FormGroup>
                    </div>
                    {/* สินค่าใหม่ new */}
                    <div className="switch-form">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  new: e.target.checked,
                                })
                              }
                              checked={addData.new ? true : false}
                            />
                          }
                          label={t('New')}
                          labelPlacement="start"
                        />
                      </FormGroup>
                    </div>
                    <div className="input-group-settings">
                      <div className="inp">
                        <ButtonUI
                          color="error"
                          onClick={(e) => priorityHandler(false)}
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </ButtonUI>
                        <span className="title">
                          {t('Priority')} {addData.priority}
                        </span>
                        <ButtonUI onClick={(e) => priorityHandler(true)}>
                          <FontAwesomeIcon icon={faAdd} />
                        </ButtonUI>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="modal-footer">
          {/* ปุ่ม */}
          <ButtonUI
            loader={true}
            isLoading={isFetching}
            className="btn-save"
            on="save"
            width="md"
            onClick={addValidators}
          >
            {t('Save')}
          </ButtonUI>
          <ButtonUI
            className="btn-cancel"
            on="cancel"
            width="md"
            onClick={() => setClose(false)}
          >
            {t('Cancel')}
          </ButtonUI>
        </div>
      </Box>
    </Modal>
  );
}

export default AgricultureAddModal;
